import { LoaderOverlay } from '@/shared/ui';

export const PageLoader = () => <LoaderOverlay show fixed />;

PageLoader.displayName = 'PageLoader';
